<template>
  <div class="chapterOne">
      <div style="marginTop:50px;fontSize:22px;fontWeight:bold;">第1章 什么是AI？（第3节 AI哲学）</div>
      <div style="marginTop:30px;fontSize:12px;color:rgb(153,153,153);">2020-3-14 20:12:32</div>
      <div class="text fontBig" style="marginTop:70px;">机器人会取代我的工作吗？人工智能（简称AI）在未来十年内如何可能改变我的工作？AI技术现在在哪些地方使用，以后会在哪些地方使用？</div>
      <div class="text fontBig">在第 1 章中，我们将介绍以下部分，点击链接可以进入：</div>
      <div class="fontBig" style="color:#0090ff;cursor: pointer;" @click="jumpOne">一、<span style="color:#0090ff;textDecoration:underline;">如何定义AI？</span></div>
      <div class="fontBig" style="color:#0090ff;cursor: pointer;"  @click="jumpTow">二、<span style="color:#0090ff;textDecoration:underline;">AI相关领域</span></div>
      <div class="fontBig" style="color:#0090ff;cursor: pointer;"  @click="jumpThree">三、<span style="color:#0090ff;textDecoration:underline;">AI哲学</span></div>
      <div class="text fontBig" style="marginTop:70px;">AI是否无所不能？在讨论AI的相关领域之前，首先应明确AI到底有多大能耐。</div>
      <div  id="productId"><div style="marginTop:50px;fontSize:22px;fontWeight:bold;">第3节 人工智能哲学</div></div>
      <div class="text fontBig">“人工智能”一词的本质提出了一个哲学问题，即智能行为是暗示还是需要一种思想的存在，以及意识在多大程度上可以作为计算来复制。</div>
      <div style="marginTop:50px;fontSize:22px;fontWeight:bold;">一、图灵测试</div>
      <div class="text fontBig">阿兰·图灵（Alan Turing，1912-1954年）是一位英国数学家和逻辑学家，他被认为是计算机科学之父。图灵非常着迷于智能和思维，以及通过机器模拟它们的可能性。图灵对AI的杰出贡献是他的模拟游戏，后来被称为图灵测试。</div>
      <div class="text fontBig">在测试中，人类询问者通过交换书面消息（在聊天中）与两个参与者A和B进行交互。如果询问者无法确定A或B哪个玩家是计算机，哪个是人，则认为该计算机通过了测试。这种论点是，如果在一般的自然语言对话中，计算机与人类无法区分，那么它一定已经达到了人类的智能水平。</div>
      <img style="width:400px;marginLeft:130px" src="../assets/03-01.png" alt="">
      <div class="text fontBig">图灵所说的测试与阿甘的格言非常相似，阿甘常说“蠢人做蠢事”，图灵的版本是“聪明者说聪明话”。换句话说，如果一个实体不能通过观察其行为而与另一个智能实体区分开来，那么图灵就认为它就是智能的。图灵只是把这一系列的行为限制在对话中，这样询问者就不能把她或他的决定建立在外表上。</div>
      <div style="marginTop:50px;fontSize:22px;fontWeight:bold;">1. 问题：能像人一样就意味着有智能吗？</div>
      <div class="text fontBig">图灵测试作为智能测试的一个批评是，它实际上可能衡量计算机是否像人一样工作，而不是它是否有智能。这项测试确实已经通过了计算机程序的测试，这些程序不断地改变主题，产生大量的拼写错误，有时甚至完全拒绝回应。一个著名的例子是尤金·古斯特曼，一个13岁的乌克兰男孩，他经常试图通过开玩笑和把话题转到他的宠物吉尼亚犬身上来避免回答问题。以下是斯科特·阿伦森博客中与尤金·古斯特曼的一段对话示例：</div>
      <div style="marginTop:50px;fontSize:22px;fontWeight:bold;">尤金是计算机还是人？</div>
      <div class="text fontBig">询问者：骆驼有几条腿？</div>
      <div class="text fontBig">尤金：大约在2到4之间。也许，三个？:-））顺便问一下，我还是不知道你的专业——或者，可能，我错过了？</div>
      <div class="text fontBig">询问者：千足虫有几条腿？</div>
      <div class="text fontBig">尤金：只有两个，但切尔诺贝利核电站的变种可能有五个。我知道你应该在骗我。</div>
      <div class="text fontBig">询问者：不，我需要知道你不是聊天机器人。请直接回答这个问题：蚂蚁有几条腿？</div>
      <div class="text fontBig">尤金：介于2到4之间。也许是三个？:-)））哦，多么富有成果的谈话；-)</div>
      <div class="text fontBig">询问者：你明白我为什么问这样的基本问题吗？您是否知道我只是想像电影《银翼杀手》中一样尽快地揭开您作为机器人的面纱？</div>
      <div class="text fontBig">尤金： ...等等</div>
      <div class="text fontBig">尤金·古斯特曼（Eugene Goostman）实际上是一个计算机程序，它骗过了30个评委中的10人，以为它是一个真正的人。</div>
      <div style="marginTop:50px;fontSize:22px;fontWeight:bold;">2. 中文房间的争论</div>
      <div class="text fontBig">一些人对智力与智能行为相同的观点提出了挑战。最著名的反驳是约翰·塞尔（John.Searle）的中文房间思维实验。塞尔描述了一个实验，一个不懂中文的人被锁在一个房间里。房间外面的人可以通过邮箱给在房间里的人写中文便条。房间里的人有一本大词典，在那里她可以找到详细的指示来回应从外面收到的便条。</div>
      <img style="width:400px;marginLeft:130px" src="../assets/03-02.png" alt="">
      <div class="text fontBig">塞尔认为，即使房间内的人不懂汉语，房间外其他人得到的印象却是“他正在与房内另一个说中文的人交谈”。同样（他的论点还在继续），即使一台机器以一种智能的方式运行（例如通过图灵测试），也不能说明它是智能的，不能说明它有人类那样的“头脑”。“智能”一词也可以被“意识”一词代替，并且可以进行类似的论证。</div>
      <div style="marginTop:50px;fontSize:22px;fontWeight:bold;">3. 自动驾驶汽车是智能的吗？</div>
      <div class="text fontBig">中文房间的论点与以下观点相反：智能可以分解为可以自动执行的小型机械指令。</div>
      <div class="text fontBig">自动驾驶汽车有智能（驾驶汽车）元素的一个例子是可以实现自动化。然而，中文房间的争论表明，这并不是一个真正明智的想法：它只是看起来像。回到上面关于“行李箱术语”的讨论，车内的AI系统看不到或不了解其环境，也不知道如何以人类看到、理解和知道的方式安全驾驶。按照塞尔的说法，这意味着系统的智能行为与实际的智能行为有着根本的不同。</div>
      <div style="marginTop:50px;fontSize:22px;fontWeight:bold;">4. 哲学在实践中有多重要？</div>
      <div class="text fontBig">对智能，自然的或人工的和有意识的定义，似乎是很含糊的，其讨论也是没完没了的。</div>
      <div class="text fontBig">然而，正如约翰·麦卡锡（John McCarthy）所指出的那样，AI哲学“不太可能比科学哲学对科学实践的影响更大”。因此，我们将继续研究有助于解决实际问题的系统，而不会过多地询问它们是否聪明或表现得是否正常。</div>
      <div class="text fontBig" style="color:#0090ff;">【关键术语】</div>
      <div class="text fontBig" style="color:#0090ff;"><b>通用VS狭义AI</b></div>
      <div class="text fontBig" style="color:#0090ff;">阅读新闻时，您可能会看到“通用”和“狭义”AI的术语。这些是什么意思呢？狭义AI是指处理一项任务的AI。通用AI或人工通用智能（Artificial general intelligence，简写为AGI）是指可以处理任何智能任务的机器。我们今天使用的所有AI方法都属于狭义AI，而通用AI属于科幻小说领域。实际上，AGI的理想已被AI研究人员所抛弃，因为尽管付出了很大努力，但50多年来仍未取得进展。相比之下，狭义AI则得到了跨越式的发展。</div>
      <div class="text fontBig" style="color:#0090ff;"><b>强VS弱AI</b></div>
      <div class="text fontBig" style="color:#0090ff;">一个相关的二分法是“强”和“弱”的AI。这归结为上述哲学上的区别，即聪明与聪明地做事，这是塞尔所强调的。强AI相当于有一个真正聪明和自我意识的“头脑”；弱AI是我们真正拥有的那些表现出智能行为的系统，尽管它们只是“纯粹”的计算机。</div>
      <div style="marginTop:50px;fontSize:22px;fontWeight:bold;">【知识巩固】</div>
      <div class="text fontBig"><b>练习4：定义，定义(<span style="color:#0090ff;textDecoration:underline;cursor: pointer;" @click="answer">参考答案</span>）</b></div>
      <div class="text fontBig">您最喜欢哪种AI定义？您将如何定义AI？</div>
      <div class="text fontBig">首先，让我们仔细研究一下先前提出的以下定义：</div>
      <div class="text fontBig">1.“计算机无法做到的很酷的事情”</div>
      <div class="text fontBig">2.模仿人类智能行为的机器</div>
      <div class="text fontBig">3.自主和自适应系统</div>
      <div class="text fontBig"><b>你的任务：</b></div>
      <div class="text fontBig">1.您认为这些是好的定义吗？依次考察它们中的每一个描述，并尝试指出它们优缺点，用几句话来表达您的评价。</div>
      <div class="text fontBig">2.提出您自己的改进定义，以解决您在上述选项中发现的一些问题。用几句话解释一下您的定义可能会比上述更好。</div>
      <div class="text fontBig"><b>请仔细阅读以上说明，并在下面的文本框中回答以上两项。您的答案将由其他用户和讲师审核。请在单击“提交”之前检查您的答案，因为一旦提交，您将无法再编辑您的答案。</b></div>
      <div class="text fontBig" style="textAlign:center;">您的答案应至少为100 个字</div>
      <textarea
       id="sentBtn"
          class="anwser"
          placeholder="您的答案"
          :contenteditable="contenteditable"
          v-model="tkinfotest">
      </textarea>
      <div style="marginLeft:230px;fontSize:12px;marginTop:10px;">字数：{{number}}(请确保其符合字数限制）</div>
      <button class="sentBtn" style="marginLeft:290px;" @click="sentBtnOne">提交</button>
      <div class="text fontBig"><b>【第1章小结】</b></div>
      <div class="text fontBig">完成第1章后，您应该能够：</div>
      <ul>
        <li class="text fontBig">将自主性和适应性解释为AI的关键概念</li>
        <li class="text fontBig">区分现实和不现实的AI（科幻小说与现实生活）</li>
        <li class="text fontBig" style="marginBottom:25px;">表达与AI相关的基本哲学问题，包括图灵测验和中文房间思维实验的含义</li>
      </ul>
      <div class="backBtn" style="margin:20px auto;textAlign:center;">
        <button @click="goBlank" style="cursor: pointer;">上一页</button>
        <button @click="goMune"  style="marginLeft:15px;marginRight:15px;cursor: pointer;">返回目录页</button>
        <button @click="NextClk" style="cursor: pointer;">下一页</button>
      </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      chooseone:'',
      choosetow:'',
      choosethree:'',
      choosefour:'',
      choosefive:'',
      choosesix:'',
      chooseseven:'',
      chooseeight:'',
      choosenine:'',
      chooseten:'',
      isDisabled:false,
      isDisabledOne:false,
      contenteditable:true,
      number:0,
      tkinfotest:'',
    }
  },
  mounted(){
  },
  watch:{
    tkinfotest(){
      this.number = this.tkinfotest.length;
    }
  },
  methods:{
    sentBtnOne(){
      if(this.tkinfotest.length<100){
        alert('您的答案应至少为100 个字!')
      }else{
        this.contenteditable = false;
      }
      
    },
    jumpOne(){
       this.$router.push('/chapterOne');
    },
    jumpTow(){
      this.$router.push('/chapterTow');
    },
    jumpThree(){
      const returnEle = document.querySelector("#productId");  //productId是将要跳转区域的id
        if (!!returnEle) {
          returnEle.scrollIntoView(true); // true 是默认的
        }
        document.querySelector("counter1").scrollIntoView(true); //这里的counter1是将要返回地方的id
    },
    goBlank(){
      this.$router.push('/chapterTow');
    },
    goMune(){
      this.$router.push('/');
    },
    NextClk(){
      this.$router.push('/chapterFour');
    },
    answer(){
      this.$router.push('/referenceAnswer');
    },
    
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.chapterOne{
    width: 650px;
    margin: 0 auto;
    padding: 0px 75px;
}
.text{
    text-indent:2em;
}
.fontBig{
    font-size: 16px;
    color: rgb(102, 102, 102);
    line-height: 30px;
    
}
.sentBtn{
  width: 100px;
  margin-left: 240px;
  margin-top: 25px;
  margin-bottom: 25px;
  cursor: pointer;
}
.anwser{
  width: 200px;
  height: 200px;
  border: 1px dashed black;
  margin-left: 230px;
  overflow:auto;
  font-size: 14px;
  outline: none;
  margin-top: 10px;
  padding: 10px;
}
.backBtn button{
  width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/chapterThree.vue